<template>
  <common-page-table
    :apiName="apiName"
    :nameRole="nameRoleEntity"
    :titleTable="$t('HRFEED статистика детальная')"
    :paramsGetData="paramsGetData"
    :fieldLand="fieldLang"
    :keyTable="'contragentId'"
    :deleteParams="()=>{}"
    :apiDeleteName="apiDeleteName"
    :alternativeConverter="convertData"
    :isDefaultConverter="false"
    :force-delete="false"
    :force-is-create="false"
    :force-is-edit="false"
    :force-is-show="false"
    :prefixShow="prefixShow"
    :hasReadOnlyInTable="hasReadOnlyInTable"
    :eventGetParamsGetData="true"
    :trigerReinit="trigerReinit"
    @setTriger="setTriger"
    :forceIsSearch="false"
    :hasAction="false"
  >
    <div>
      <div class="col-sm-12">
        <FilterBlockStatistic :filter-list="filterList" :filterData="filterData" :defaultDataIn="defaultDataIn" />
      </div>
    </div>
  </common-page-table>
</template>
<script>
import { NAME_OBJECT } from "../../../../RoleConstanans";
import CommonPageTable from "../../commonElement/CommonPageTable.vue";
import { API_METHODS,  GLOBAL_DATE_TIME_FORMAT } from "../../../../constant";
import convertLangDataToTable from "../../../../helpers/converters/convertLangDataToTable";
import FilterBlockStatistic from "./FilterBlockStatistic.vue";

export default {
  name: "StatisticHrFeedTable",
  components: { CommonPageTable, FilterBlockStatistic },
  props: {
    hasReadOnlyInTable: { type: Boolean, default: true },
    routeField: { type: String, default: "CompanyId" }
  },
  data() {
    return {
      defaultDataIn: null,
      trigerReinit: false,
      dateFrom: "",
      dateTo: "",
      fieldLang: "",
      apiName: API_METHODS.GET_STATISTIC_HR_FEED,
      apiDeleteName: "",
      filterList: [{
        "code": "dateFrom",
        "name": "Период от",
        "type": "Date",
        "refEntityCode": null,
        "colWidth": 6,
        "subListId": 0,
        "watchAttr": null
      },
        {
          "code": "dateTo",
          "name": "До",
          "type": "Date",
          "refEntityCode": null,
          "colWidth": 6,
          "subListId": 0,
          "watchAttr": null
        }
      ]
    };
  },
  created() {
    const { dateFrom, dateTo } = this.$route.params
    this.dateFrom = this.$moment(dateFrom).format("YYYY-MM-DD");
    this.dateTo = this.$moment(dateTo).format("YYYY-MM-DD");
    this.defaultDataIn = {
      dateFrom :this.dateFrom,
      dateTo: this.dateTo
    }
  },
  computed: {
    paramsGetData() {
      const { contragentId } = this.$route.params
      return {
        paramsDop: {
          contragentId,
          dateFrom: this.dateFrom,
          dateTo: this.dateTo
        }
      };
    },
    prefixEdit() {
      return null;
    },
    prefixShow() {
      return this.prefixEdit;
    },
    linkCreate() {
      return this.prefixEdit + "/create";
    },
    nameRoleEntity() {
      let role = NAME_OBJECT.StatisticHrFeed;
      return role;
    }
  },
  methods: {
    convertData(dataNow, langNow) {
      let res = convertLangDataToTable(dataNow, langNow, "", false);
      res = res.map(el => {
        return {
          ...el,
          processed: this.$moment(el.processed).format(
            GLOBAL_DATE_TIME_FORMAT
          )
        };
      });
      return res;
    },
    filterData(val) {
      if(this.dateFrom == val.dateFrom && this.dateTo == val.dateTo) {
        this.trigerReinit = true;
      } else {
        this.dateFrom = val.dateFrom;
        this.dateTo = val.dateTo;
      }
    } ,
    setTriger(){
      this.trigerReinit = false;
    },
  }
};
</script>
